






import Vue from 'vue';
import axios from 'axios';
import store from './store';
import router from './router';

export default Vue.extend({
  name: 'App',
  data: () => ({}),
  created: () => {
    //In case of 401 error, the token is removed and the user redirected to the login page
    axios.interceptors.response.use(undefined, err => {
      return new Promise(() => {
        if (err.response.status === 401) {
          const orgname = store.getters['org/getShortName'];
          store.dispatch('auth/logout');
          router.push(`/${orgname}`, () => {
            localStorage.setItem('tokenExpired', 'true');
          });
        }
        throw err;
      });
    });

    document.title = `3rd Party Portal`;
  },
});
